import React from 'react';
import { Link } from '@mm/components';
import { Routes } from '../../routes/top-level-routes';
import { Template } from './Template';

export const EUSpecificPolicy = () => (
  <div>
    <h1 style={{ marginBottom: '13px' }}>
      Customers.ai’s EU-Specific Privacy Policy
    </h1>
    <p>
      <span>
        This Privacy Policy applies to EU residents only. If you are not an EU
        resident, our Standard&nbsp;
        <Link to={Routes.privacyPolicy.path}>Privacy Policy </Link>
        applies to you.
      </span>
    </p>
    <p>
      <span>
        <u>Customers.ai’s EU-Specific Privacy Policy</u>
      </span>
    </p>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        Thank you for your interest in our services, products (collectively, our
        “<strong>Products</strong>”), and website (https://Customers.ai), (our “
        <strong>Website</strong>” and together with our services and Products,
        our “<strong>Services</strong>”). Your Privacy is important to us and we
        are committed to protecting and respecting your privacy. This Privacy
        Policy sets out details about how we collect, store, process, transfer
        and use data that identifies or is associated with you, as a natural
        person (hereinafter “<strong>personal information</strong>“) and which
        is subject to the European Data Protection Regulation (the “
        <strong>GDPR</strong>”). This is the case for visitors and users of our
        Services located in the European Union, European Economic Area and other
        users who provide us with personal information subject to the GDPR.
        Personal information covers all personal data as defined under Art. 4(1)
        GDPR.
      </span>
    </p>
    <p>
      <span>
        This Privacy Policy does not describe the processing of personal
        information
      </span>
    </p>
    <ul>
      <li>
        <span>
          to visitors/users located outside the European Union or European
          Economic Area, and
        </span>
      </li>
      <li>
        <span>
          If you have any questions relating to our processing of personal
          information described under (i), please have a look at [Customers.ai
          Privacy Policy], or under (ii), please consult with the EU entity who
          is responsible for the processing of your personal
        </span>
      </li>
    </ul>
    <h1>
      <span>
        1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>Who is the data controller of your personal information?</u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        We, Customers.ai Inc, 359 Newbury Street, Boston MA 02115 USA, (“
        <strong>Customers.ai</strong>” or “<strong>we</strong>”) is the data
        controller. We are responsible for, and control, the processing of your
        personal information.
      </span>
    </p>
    <p>
      <span>
        If you wish to contact us, you can find our contact details at the end
        of this Privacy Policy.
      </span>
    </p>
    <h1>
      <span>
        2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>What personal information do we collect?</u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        In the context of rendering our Services, we may collect information
        about you. This information regularly includes the following:
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>If you create an Account</strong>: Your name, email address,
          time zone and a list of Facebook Pages you own (page names, IDs,
          categories, number of likes), your company name, Website Address,
          phone number, and the type of Business you are in.
        </span>
      </li>
      <li>
        <span>
          <strong>If you use our Products or Services: </strong>Your name,
          gender, language settings, time zone and avatar picture as long as
          your privacy settings permit access to these pieces of
        </span>
      </li>
      <li>
        <span>
          <strong>
            If you use third-party account credentials to log in to our Services
          </strong>
          : We may collect some information associate with your third-party
          account such as your name, email address, time zone and a list of
          Facebook Pages you own (page names, IDs, categories, number of likes).
        </span>
      </li>
      <li>
        <span>
          <strong>
            If you contact us (via our Website or via phone, email or letter),
            e.g. for a support request, respond to a survey, or send us an
            inquiry
          </strong>
          : Name, e-mail address, IP address, information on our communication
          with you and any additional information you provide us
        </span>
      </li>
      <li>
        <span>
          <strong>If you merely use our Website</strong>: Our server logs from
          your browser or device, which may include any chatbots you have
          created using our Services, your conversation history with the
          chatbots, IP address, geolocation data, device identification, browser
          data, browser type (user agent, browser version, etc.), device type,
          device model, operating system version, screen resolution, information
          on your usage of our Website (list visited pages, etc) and online
          activities and information obtained with the use of cookies (
          <em>see section 9 below</em>).
        </span>
      </li>
    </ul>
    <p>
      <span>
        Please note that this Privacy Policy does not cover personal information
        you provide to our clients when using chatbots created with the use of
        our Services that are located on our clients’ websites, as we do not
        control the means and purposes of such personal data processing as
        defined in Article 4(7) of the GDPR. Typically, our clients, who are
        owners of chatbots created through our Service will be able to collect
        your conversation history with the client’s chatbot, and information
        contained in your public social media profile, such as your name, your
        avatar photo, your time zone, your gender, your language settings, and
        any other information you provide through the said chatbot. Our clients
        may also use third party product integration to receive and process
        personal information you have provided. Please consult our clients’
        privacy policies for such data processing activities.
      </span>
    </p>
    <h1>
      <span>
        3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>How do we collect your information?</u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        This personal information is collected in many ways and may include:
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>personal information you provide to us</strong>: Most of the
          personal information we receive comes to us voluntarily from our users
          in the course of using our Services, such as when visiting our
          Website, communicating with us or in the process of requesting our
        </span>
      </li>
    </ul>
    <p>
      <span>
        You are free to choose which information you want to provide to us or
        whether you want to
      </span>
    </p>
    <p>
      <span>
        provide us with information at all. However, some information, such as
        your name, email address, Facebook ID, and information on your requested
        Services may be necessary for the performance of our contractual
        obligations. Without providing this information, you will not be able to
        order certain Services or enter into a contract with us.
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>personal information collected via technology</strong>: As you
          use our Website, we may collect passive information through the use of
          cookies. Please see section 9 below for more
        </span>
      </li>
      <li>
        <span>
          <strong>personal information we receive from others</strong>: We may
          receive personal information about users from third parties such as
          social media sites, law enforcement agencies, providers of denied
          party screening and marketing
        </span>
      </li>
    </ul>
    <h1>
      <span>
        4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>
          Why and on which legal basis do we collect and use your personal
          information?
        </u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        Please note, the notice on the legal grounds refers to the legal
        justifications under the GDPR which only applies to our operations to
        the extent we service or monitor EU residents.
      </span>
    </p>
    <p>
      <span>
        The reasons for using your personal information may differ depending on
        the purpose of the collection. Regularly we use your information for the
        following purposes and on the following legal grounds:
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>
            We use your information in order to perform our contractual services
            or prior to entering into a contract with you
          </strong>
          . If you order Services from Customers.ai or if you contact us to
          request our Services, we use your information to provide you with
          these Services. Information we use includes: information we need to
          contact you or otherwise communicate with you; if you are a registered
          user: information to manage your account; information to enable the
          usage of Services; information for invoicing and payment follow
        </span>
      </li>
      <li>
        <span>
          <strong>
            We use your information if justified by our legitimate interests
          </strong>
          . The usage of your information may also be necessary for our own
          business interests. For example, we may use some of your information
          to evaluate and review our business performance, create financial
          statements; improve our Services or to identify potential cyber
          security threats. If necessary we may also use your information to
          pursue or defend ourselves against legal claims. We may use your email
          address and names for our email marketing campaigns. You can opt out
          to this use at any time by following the link to unsubscribe at the
          bottom of our marketing
        </span>
      </li>
      <li>
        <span>
          <strong>We use your information after obtaining your consent</strong>.
          In some cases, we may ask you to grant us separate consent to use your
          information. You are free to deny your consent but doing so may mean
          some or all of our Services will not be available. You are free to
          withdraw your consent at any time with effect for the future. If you
          have granted us consent to use your information, we will use it only
          for the purposes specified in the consent
        </span>
      </li>
    </ul>
    <p>
      <span>
        This also includes our <strong>marketing campaigns</strong>. If you sign
        up to our email newsletter or when providing us with your email address
        to allow us to use this email address for email marketing, we will use
        your personal information in our email marketing campaigns. You may
        unsubscribe from our email newsletter at any time by following the link
        to unsubscribe at the bottom of our marketing emails. You may also
        contact us via email address provided at the end of this Privacy Policy
        to request that we remove you from our email list.
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>
            We use your information to comply with legal obligations
          </strong>
          . We are obligated to retain certain information because of legal
          requirements, for example, tax or commercial
        </span>
      </li>
    </ul>
    <p>
      <span>
        We will only use your information for the purposes for which we have
        collected them. We will not use your information for other purposes. We
        do not use your personal information for automated individual
        decision-making.
      </span>
    </p>
    <h1>
      <span>
        5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>With whom do we share your Personal &nbsp;Information?</u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        We will share your personal information with the following third
        parties:
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>Service providers and advisors</strong>: Third party vendors
          and other service providers that perform services for us or on our
          behalf, which may include marketing campaign services, providing
          mailing or email services, tax and accounting services, product
          fulfilment, payment processing, data enhancement services, fraud
          prevention, web hosting, or providing analytics services; These third
          parties include: Google Cloud, Microsoft Azure, MailChimp, Recurly,
          Stripe, Facebook, etc. Any such service providers will by appropriate
          data processing agreements be bound to only process the data on
          Customers.ai’s behalf and under its
        </span>
      </li>
      <li>
        <span>
          <strong>Promotional partners</strong>: Third parties with whom we
          partner to provide promotional activities, which will be identified by
          name in the context of these activities. Customers.ai has partnered
          with third parties who provide promotional activities in the past and
          intends to partner with them in the future. However, Customers.ai does
          not partner with any such third party at the moment. These partners
          will be identified by name in the context of these
        </span>
      </li>
      <li>
        <span>
          <strong>
            Purchasers and third parties in connection with a business
            transaction
          </strong>
          : Personal information may be disclosed to third parties in connection
          with a Customers.ai-related transaction, such as a merger, sale of
          Customers.ai’s assets or shares, reorganization, financing, change of
          control or acquisition of all or a portion of our business, or in the
          event of a bankruptcy or similar
        </span>
      </li>
      <li>
        <span>
          <strong>
            Law enforcement, regulators and other parties for legal reasons
          </strong>
          : Third parties as required by law or subpoena or if we reasonably
          believe that such action is necessary to (a) comply with the law and
          the&nbsp;
        </span>
        reasonable requests of law enforcement; (b) to enforce our legal claims
        or to protect the security or integrity of our Services; and/or (c) to
        exercise or protect the rights, property, or personal safety of
        Customers.ai, our visitors, or others.
      </li>
    </ul>
    <h1>
      <span>
        6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>How long do we keep your information</u>
        <u>?</u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        We will store personal information for as long as necessary to fulfil
        the purposes for which we collect the personal information, in
        accordance with our legal obligations and legitimate business interests.
      </span>
    </p>
    <h1>
      <span>
        7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>How do we protect your information?</u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        We implement a variety of security measures to maintain the safety of
        your personal information when you use our Services. In the event that
        any information under our control is compromised as a result of a breach
        of security, we will take reasonable steps to investigate the situation
        and, where appropriate, notify those individuals whose information may
        have been compromised and take other steps, in accordance with any
        applicable laws and regulations.
      </span>
    </p>
    <h1>
      <span>
        8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>
          How do we safeguard your personal information when there is an
          international transfer?
        </u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        As we are located in the USA, any information you provide, will be
        processed and stored in the USA. If you are in the European Union or
        European Economic Area, this may mean that your personal information
        will be stored in a jurisdiction that offers a level of protection that
        may, in certain instances, be less protective of your personal
        information than the jurisdiction you are typically a resident in.
      </span>
    </p>
    <p>
      <span>
        If you wish to inquire further about the safeguards we use, please
        contact us using the details set out at the end of this Privacy Policy.
        We will take reasonable steps to ensure that your personal information
        is treated securely and in accordance with applicable law and this
        Privacy Policy.
      </span>
    </p>
    <h1>
      <span>
        9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
        <u>Cookies and other tracking technologies.</u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        The Services use cookies, web beacons, file information and similar
        technologies to distinguish you from other users of the Services. This
        helps us to provide you with a good experience when you browse the
        Services and also allows us to improve the Services.
      </span>
    </p>
    <p>
      <span>
        Cookies are pieces of code that allow for personalization of the
        Services experience by saving your information such as user ID and other
        preferences. A cookie is a small data file that we transfer to your
        device’s hard disk (such as your computer or smartphone) for
        record-keeping purposes.
      </span>
    </p>
    <p>
      <span>
        We use or may use the data collected through tracking technologies to:
        (a) remember information so that you will not have to re-enter it during
        your visit or the next time you visit the site; (b) provide custom,
        personalized content and information, including targeted content and
        advertising; (c) identify you across multiple devices;
      </span>
    </p>
    <ul>
      <li>
        <span>
          provide and monitor the effectiveness of our Services; (e) monitor
          aggregate metrics such as total number of visitors, traffic, usage,
          and demographic patterns on our Website; (f) diagnose or fix
          technology problems; and (g) otherwise to plan for and enhance our
        </span>
      </li>
      <li>
        <span>
          <strong>Strictly necessary cookies. </strong>These are cookies that
          are required for the essential operation of the Services such as to
          authenticate users and prevent fraudulent
        </span>
      </li>
      <li>
        <span>
          <strong>Analytical/performance cookies</strong>. These allow us to
          recognize and count the number of visitors and to see how visitors
          move around the Services when they are using it. This helps us to
          improve the way the Services work, for example, by ensuring that users
          are finding what they are looking for
        </span>
      </li>
      <li>
        <span>
          <strong>Functionality cookies</strong>. These are used to recognize
          you when you return to the Services. This enables us to personalize
          our content for you, greet you by name and remember your preferences
          (for example, your choice of language or region).
        </span>
      </li>
      <li>
        <span>
          <strong>Targeting cookies</strong>. These cookies record your visit to
          our Website, the pages you have visited, the links you have followed
          and may also gather information about your online activity after you
          leave our Website. We will use this information to make our Website,
          the advertising displayed on it, and the marketing messages we send to
          you more relevant to your interests. We may also share this
          information with third parties who provide a service to us for this
        </span>
      </li>
      <li>
        <span>
          <strong>Third party cookies</strong>. Please be aware that advertisers
          and other third parties may use their own cookies tags when you click
          on an advertisement or link on our Website. These third parties are
          responsible for setting out their own cookie and privacy
        </span>
      </li>
    </ul>
    <h1>
      <span>How to manage cookies?</span>
      <span>
        <strong>&nbsp;</strong>
      </span>
    </h1>
    <p>
      <span>
        The cookies we use are designed to help you get the most from the
        Services but if you do not wish to receive cookies, most browsers allow
        you to change your cookie settings. Please note that if you choose to
        refuse cookies you may not be able to use the full functionality of the
        Services. These settings will typically be found in the “options” or
        “preferences” menu of your browser. In order to understand these
        settings, the following links may be helpful, otherwise you should use
        the “Help” option in your browser for more details.
      </span>
    </p>
    <ul>
      <li>
        <span>
          <a href="https://support.microsoft.com/en-us/products/windows">
            Cookie settings in Internet Explorer
          </a>
        </span>
      </li>
      <li>
        <span>
          <a href="http://support.mozilla.org/en-US/kb/cookies">
            Cookie settings in Firefox
          </a>
        </span>
      </li>
      <li>
        <span>
          <a href="https://support.google.com/chrome/answer/95647?hl=en">
            Cookie settings in Chrome
          </a>
        </span>
      </li>
      <li>
        <span>
          <a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac">
            Cookie settings in Safari web{' '}
          </a>
          and
          <a href="https://support.apple.com/kb/ph21411?locale=en_US">
            {' '}
            https://support.apple.com/kb/ph21411?locale=en_US
          </a>
          .
        </span>
      </li>
    </ul>
    <h1>
      <span>Other Tools</span>
    </h1>
    <p>
      <span>
        <strong>10.&nbsp;</strong>&nbsp;{' '}
        <u>What rights and choices do you have?</u>
      </span>
    </p>
    <p>
      <span>
        We want you to understand your rights and choices regarding how we may
        use your personal information. Depending on how you use your
        information, these rights and choices may include the following:
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>Individual Rights</strong>. You have specific rights under
          applicable privacy law in respect to your personal information that we
          hold, including a right of access and erasure and a right to prevent
          certain processing
        </span>
      </li>
    </ul>
    <p>
      <span>
        If you are a resident in the European Union or European Economic Area,
        you have the following rights in respect to your personal information
        that we hold:
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>Right of access</strong>. The right to obtain access to your
          personal
        </span>
      </li>
      <li>
        <span>
          <strong>Right to rectification</strong>. The right to obtain
          rectification of your personal information without undue delay where
          that personal information is inaccurate or
        </span>
      </li>
      <li>
        <span>
          <strong>Right to erasure</strong>. The right to obtain the erasure of
          your personal information without undue delay in certain
          circumstances, such as where the personal information is no longer
          necessary in relation to the purposes for which it was collected or
        </span>
      </li>
      <li>
        <span>
          <strong>Right to restriction</strong>. The right to obtain restriction
          of the processing undertaken by us on your personal information in
          certain circumstances, such as, where the accuracy of the personal
          information is contested by you, for a period of time enabling us to
          verify the accuracy of that personal
        </span>
      </li>
      <li>
        <span>
          <strong>Right to portability</strong>. The right to portability allows
          you to move, copy or transfer personal information easily from one
          organization to
        </span>
      </li>
      <li>
        <span>
          <strong>Right to object</strong>. You have a right to object to any
          processing based on our legitimate interests where there are grounds
          relating to your particular situation. You can object to marketing
          activities for any reason
        </span>
      </li>
    </ul>
    <p>
      <span>
        If you wish to exercise one of these rights, please contact us using the
        contact details below. For cookies or e-mail marketing, we provide the
        following easily usable option:
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>E-Mail Settings and Preferences</strong>. If you no longer
          want to receive marketing e-mails from us, you may choose to
          unsubscribe at any time by following the unsubscribe instructions
          included in our email footers
        </span>
      </li>
    </ul>
    <h1>
      <span>
        11.&nbsp;&nbsp; <u>How to contact us?</u>
      </span>
    </h1>
    <p>
      <span>
        If you have any questions or concerns about our Privacy Policy, please
        send an email to <u>Contact</u>@Customers.ai
      </span>
    </p>
    <h1>
      <span>
        12.&nbsp;&nbsp; <u>Online Privacy Policy Updates</u>
      </span>
    </h1>
    <p>
      <span>
        <strong>&nbsp;</strong>
      </span>
      <span>
        We may make changes to our Privacy Policy from time to time. Please
        review our policies regularly as updated policies will apply to your
        future use of our Services.
      </span>
    </p>
  </div>
);

export const EUSpecificPolicyPage = () => (
  <Template>
    <EUSpecificPolicy />
  </Template>
);
